export default __webpack_public_path__ + "static/media/menu_top_duet.d4cc3b92.svg";